<template>
  <v-container class='navbar__container py-2' fluid>
    <v-col offset-sm='1' sm='10'>
      <v-row>
        <div class='logo'>
          <v-img alt='SSAU logo' src='/logo-white-goriz.svg' />
        </div>

        <div class='navbar'>
          <router-link class='navbar-item' v-for='(item, index) in navbarMenuList' :key='index' :to='item.path'>
            {{ item.name }}
          </router-link>
        </div>

        <div v-if='isAdmin'>
          <v-tooltip color='#2196F3FF'>
            <template #activator='{ on }'>
              <v-btn color='white' class='mt-1 mr-10' absolute right icon v-on='on' @click='switchStateViewAdminPanel'>
                <v-icon v-if='isViewAdminPanel'>
                  mdi-shield-account
                </v-icon>
                <v-icon v-else>
                  mdi-account-outline
                </v-icon>
              </v-btn>
            </template>
            <span v-if='isViewAdminPanel'>Скрыть интерфейс администратора</span>
            <span v-else>Отобразить интерфейс администратора</span>
          </v-tooltip>

          <v-tooltip color='#2196F3FF'>
            <template #activator='{ on }'>
              <v-btn color='white' class='mt-1' absolute right icon v-on='on' @click='logout'>
                <v-icon>
                  mdi-logout-variant
                </v-icon>
              </v-btn>
            </template>
            <span>Выход из аккаунта</span>
          </v-tooltip>
        </div>

      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: 'LayoutNavbar',
  data() {
    return {
      testData: true,

      navbarMenuList: [
        { name: 'ГЛАВНАЯ', path: '/main' },
        { name: 'О ЛАБОРАТОРИИ', path: '/lab' },
        { name: 'КОЛЛЕКЦИИ', path: '/collections' },
        { name: 'ПУБЛИКАЦИИ', path: '/articles' },
        { name: 'НОВОСТИ', path: '/news' },
        { name: 'КОНТАКТЫ', path: '/contacts' },
        { name: 'ЦИТИРОВАНИЕ', path: '/citation' },
      ],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.getIsAuth;
    },

    isViewAdminPanel() {
      return this.$store.getters.getIsViewAdminPanel;
    },
  },
  methods: {
    switchStateViewAdminPanel() {
      const newState = !this.isViewAdminPanel;

      localStorage.setItem('isViewAdminPanel', newState);
      this.$store.commit('setStatusViewAdminPanel', newState);
    },

    logout() {
      this.$store.dispatch('logout');
    }
  },
};
</script>

<style lang='scss' scoped>
@import "src/assets/styles/theme.scss";

.logo {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 5px 0;
  text-align: left;
}

.test {
  display: flex;
  flex-direction: row;
  padding: 12px 0 12px 16px;
  text-align: left;
  align-items: center;
  height: 100%;
}

.navbar {
  border-left-color: rgba(255, 255, 255, 0.4);
  border-left-style: solid;
  border-left-width: 1px;
  display: flex;
  flex-direction: row;
  font-size: var($font-size-3);
  font-weight: 400;
  line-height: 24px;
  padding: 12px 0 12px 16px;
  text-align: left;
  align-items: center;
  height: 100%;
}

.navbar-item {
  background-color: transparent;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  font-size: $font-size-4;
  font-style: normal;
  font-weight: 550;
  line-height: 20px;
  margin-left: 16px;
  margin-right: 16px;
  white-space: nowrap;
  position: relative;
  text-align: left;
  text-decoration-color: rgba(255, 255, 255, 0.7);
  text-decoration-line: none;
  text-decoration-style: solid;
  text-decoration-thickness: auto
}

.navbar-item::after {
  content: "";
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: $color-orange;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: .3s;
  transition: .3s;
}

.navbar-item:hover::after, .navbar-item.router-link-active::after {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

a.router-link-active {
  color: $color-white;
}

@media (max-width: $breakpoint-xl) {
  .navbar {
    border: 0;
    margin: 0 auto;
  }

  .logo {
    width: 100%;
    margin: 0;
  }
  .logo img {
    margin: 0 auto;
  }
}

</style>